<template>
  <TransitionGroup name="list" tag="ul">
    <li v-for="notification in notificationList" :key="notification.id">
      <div class="tw:bg-red-200 tw:absolute tw:w-full tw:text-sm tw:md:flex tw:relative tw:md:gap-4 tw:md:px-4">
        <div
          class="tw:py-4 tw:relative tw:flex-col tw:md:flex-row tw:flex tw:w-full tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:mx-auto xl:tw:px-4 tw:md:justify-between tw:md:items-center"
        >
          <div class="tw:flex tw:flex-row tw:items-start tw:gap-x-3">
            <img :src="ErrorIcon" alt="Error" class="tw:pt-1" />
            <div>
              <div class="tw:flex tw:items-center">
                <strong>{{ $t(notification.header) }}</strong>
              </div>
              <i18n-t v-if="notification.withSlot" :keypath="notification.message" tag="p">
                <template v-slot:[notification.slotName]>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    class="tw:text-blue-800 tw:hover:cursor-pointer tw:hover:underline"
                    :href="notification.linkUrl"
                    >{{ $t(notification.linkLabel) }}</a
                  >
                </template>
              </i18n-t>
              <p v-else>{{ notification?.messageTranslationKey ? $t(notification.message) : notification.message }}</p>
            </div>
          </div>
          <slot name="ctaContent" />
          <button
            class="tw:outline-none tw:absolute tw:right-2 tw:top-2.5"
            @click="closePaymentNotification(notification.id)"
            @keydown.enter="closePaymentNotification(notification.id)"
          >
            <Close class="tw:size-4" />
          </button>
        </div>
      </div>
    </li>
  </TransitionGroup>
</template>
<script setup>
import { computed } from 'vue'

import Close from '@/components/icons/Close.svg?component'

import usePaymentNotifications from '@/components/notifications/usePaymentNotifications'

const { paymentNotifications, closePaymentNotification } = usePaymentNotifications()
const notificationList = computed(() => Object.values(paymentNotifications?.value ?? {}))

const ErrorIcon = new URL('/src/assets/img/general/CloseCircleIcon.svg', import.meta.url)
</script>
<style scoped>
.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: opacity 0.3s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
}
</style>
